module.exports = __webpack_public_path__ + "static/media/052.b63da11c.png";